// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import {
//   Box, TextField, MenuItem, Paper, Table, TableBody, TableCell,
//   TableContainer, TableHead, TableRow, Button, CircularProgress, Tabs, Tab
// } from "@mui/material";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import "./MapParameter.css";
// import apiService from "../../utils/apiservice";



// const API_URL = process.env.REACT_APP_API_DJANGO_URL;

// const MapSiteToEngineer = () => {
//   const [supervisors, setSupervisors] = useState([]);
//   const [sites, setSites] = useState([]);
//   const [selectedSupervisor, setSelectedSupervisor] = useState("");
//   const [selectedSite, setSelectedSite] = useState("");
//   const [assignedEngineers, setAssignedEngineers] = useState([]);
//   const [availableEngineers, setAvailableEngineers] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [tabValue, setTabValue] = useState(0);
//   const [selectedSupervisorDbId, setSelectedSupervisorDbId] = useState(""); // ✅ NEW
//   const [selectedSiteObj, setSelectedSiteObj] = useState(null);


//   const [customers, setCustomers] = useState([]);
//   const [selectedCustomer, setSelectedCustomer] = useState("");
//   const [engineers, setEngineers] = useState([]);
//   // Add these inside MapSiteToEngineer component
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(5);

//   // Reset page to 0 whenever the tab, supervisor, or site changes
//   useEffect(() => {
//     setPage(0);
//   }, [tabValue, selectedSupervisor, selectedSite]);

//   const handleChangePage = (event, newPage) => setPage(newPage);
//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };
//   const getConfig = () => ({
//     headers: {
//       Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
//       Accept: "application/json",
//       "Content-Type": "application/json",
//     },
//     data: {},
//   });

//   // 1. Initial Load: Fetch Supervisors for the Customer
//   //  useEffect(() => {
//   //   const fetchSupervisors = async () => {
//   //     try {
//   //       const customerId = localStorage.getItem("customer_id");
//   //       // const res = await axios.get(
//   //       //   `${API_URL}/api/get_supervisors/${customerId}/`,
//   //       //   getConfig()
//   //       // );
//   //       const res = await apiService.get(`/api/get_supervisors/${customerId}/`, { data: {} });

//   //       const sups = res.data.supervisors || [];
//   //       setSupervisors(sups);

//   //       // ✅ AUTO SELECT FIRST SUPERVISOR
//   //       if (sups.length > 0) {
//   //         const firstSup = sups[0];
//   //         const uuid = firstSup.id?.id || firstSup.id;

//   //         setSelectedSupervisor(uuid); // UUID
//   //         setSelectedSupervisorDbId(firstSup.supervisor_id); // INTEGER

//   //         // ✅ ALSO FETCH SITES AUTOMATICALLY
//   //         fetchSitesForSupervisor(uuid);
//   //       }

//   //     } catch (err) {
//   //       toast.error("Failed to load supervisors");
//   //     }
//   //   };

//   //   fetchSupervisors();
//   // }, []);


//   useEffect(() => {
//     const fetchCustomers = async () => {
//       try {
//         const res = await apiService.get("/api/get_customers/");
//         const list = res.data || [];

//         setCustomers(list);

//         if (list.length > 0) {
//           const first = list[0].tb_customer_id;
//           setSelectedCustomer(first);

//           const siteData = await fetchCustomerSites(first);
//           await fetchEngineers(first);

//           if (siteData.length > 0) {
//             const firstSite = siteData[0];

//             setSelectedSite(firstSite.asset_id);
//             setSelectedSiteObj(firstSite);
//           }
//         }
//       } catch (err) {
//         toast.error("Failed to load customers");
//       }
//     };

//     fetchCustomers();
//   }, []);


//   // const fetchSitesForSupervisor = async (uuid) => {
//   //   try {
//   //     setLoading(true);

//   //     const siteRes = await axios.get(
//   //       `${API_URL}/api/supervisor_sites/${uuid}/`,
//   //       getConfig()
//   //     );

//   //     setSites(siteRes.data.sites || []);

//   //   } catch (err) {
//   //     toast.error("Failed to fetch supervisor sites");
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // };



//   const fetchCustomerSites = async (customerId) => {
//     try {
//       setLoading(true);

//       const res = await apiService.get(
//         `/api/get_customer_sites/${customerId}/`, {
//         data: {}
//       }
//       );

//       const siteData = res.data.data || [];
//       setSites(siteData);
//       return siteData;
//     } catch (err) {
//       toast.error("Failed to load sites");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // 2. When Supervisor changes: Fetch their Sites & their Engineers
//   // const handleSupervisorChange = async (e) => {
//   //   const selectedUUID = e.target.value;

//   //   const selectedSupObj = supervisors.find(
//   //     (sup) => (sup.id?.id || sup.id) === selectedUUID
//   //   );

//   //   setSelectedSupervisor(selectedUUID);
//   //   setSelectedSupervisorDbId(selectedSupObj?.supervisor_id);

//   //   setSelectedSite("");
//   //   setAssignedEngineers([]);
//   //   setAvailableEngineers([]);

//   //   fetchSitesForSupervisor(selectedUUID); // ✅ reuse
//   // };

//   const fetchEngineers = async (customerId) => {
//     try {
//       const res = await apiService.get(
//         `/api/get_customer_engineers/${customerId}/`,
//         { data: {} }
//       );

//       const engList = res.data.engineers || [];

//       const validEngineers = engList.filter(e => e.user_id);

//       setEngineers(validEngineers);

//       // Separate assigned vs available
//       const assigned = validEngineers
//         .filter(e => e.assigned_sites && e.assigned_sites.length > 0)
//         .map(e => ({
//           user_id: e.user_id,
//           first_name: e.first_name,
//           last_name: e.last_name,
//           isAssigned: true
//         }));

//       const available = validEngineers
//         .filter(e => !e.assigned_sites || e.assigned_sites.length === 0)
//         .map(e => ({
//           user_id: e.user_id,
//           first_name: e.first_name,
//           last_name: e.last_name,
//           isAssigned: false
//         }));

//       setAssignedEngineers(assigned);
//       setAvailableEngineers(available);

//     } catch (err) {
//       toast.error("Failed to fetch engineers");
//       setEngineers([]);
//       setAssignedEngineers([]);
//       setAvailableEngineers([]);
//     }
//   };

//   const handleCustomerChange = (e) => {
//     const customerId = e.target.value;

//     setSelectedCustomer(customerId);

//     // reset UI
//     setSites([]);
//     setSelectedSite("");
//     setAssignedEngineers([]);
//     setAvailableEngineers([]);

//     // fetch base data
//     fetchCustomerSites(customerId);
//     fetchEngineers(customerId);   // ✅ important (ONLY ONCE)
//   };

//   // 3. When Site changes: Fetch the mapping for Engineers
//   // const handleSiteChange = async (e) => {
//   //   const assetId = e.target.value;

//   //   const siteObj = sites.find(s => s.asset_id === assetId);

//   //   setSelectedSite(assetId);      // for dropdown
//   //   setSelectedSiteObj(siteObj);   // ✅ store full object

//   //   if (!selectedSupervisor) return;

//   //   try {
//   //     setLoading(true);

//   //     const engRes = await axios.get(
//   //       `${API_URL}/api/supervisor_engineers/${selectedSupervisor}/`,
//   //       getConfig()
//   //     );
//   //     const team = engRes.data.engineers || [];

//   //     const assignedRes = await axios.get(
//   //       `${API_URL}/api/get_assigned_engineers/${selectedSupervisor}/`,
//   //       getConfig()
//   //     );

//   //     const assignedList = assignedRes.data.assigned_engineers || [];

//   //     // ✅ USE site_id (INTEGER)
//   //     const assignedForSite = assignedList.filter(
//   //       (eng) => eng.site_id === siteObj.asset_id
//   //     );

//   //     const assigned = assignedForSite.map((eng) => ({
//   //       user_id: eng.engineer_id,
//   //       first_name: eng.engineer_name.split(" ")[0],
//   //       last_name: eng.engineer_name.split(" ")[1] || "",
//   //       isAssigned: true,
//   //     }));

//   //     const assignedIds = assigned.map((a) => a.user_id);

//   //     const available = team
//   //       .filter((eng) => !assignedIds.includes(eng.user_id))
//   //       .map((eng) => ({
//   //         user_id: eng.user_id,
//   //         first_name: eng.first_name,
//   //         last_name: eng.last_name,
//   //         isAssigned: false,
//   //       }));

//   //     setAssignedEngineers(assigned);
//   //     setAvailableEngineers(available);

//   //   } catch (err) {
//   //     toast.error("Failed to fetch mapping data");
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // };


//   const handleSiteChange = async (e) => {
//     const assetId = e.target.value;

//     const siteObj = sites.find(s => s.asset_id === assetId);

//     setSelectedSite(assetId);
//     setSelectedSiteObj(siteObj);

//    if (!selectedCustomer || !siteObj || engineers.length === 0) {
//   return;
// }

//     try {
//       setLoading(true);

//       // ✅ 1. USE CACHED ENGINEERS (NO API CALL HERE)
//       const allEngineers = [...engineers];

//       // ✅ 2. ONLY FETCH ASSIGNED ENGINEERS FOR SITE
//       const assignedRes = await axios.get(
//         `${API_URL}/api/get_assigned_engineers/${siteObj.site_id}/`,
//         getConfig()
//       );

//       const assignedList = assignedRes.data.assigned_engineers || [];

//       // ✅ 3. MAP ASSIGNED
//       const assigned = assignedList.map((eng) => ({
//         user_id: eng.user_id,
//         first_name: eng.first_name,
//         last_name: eng.last_name,
//         isAssigned: true,
//       }));
//       const assignedIds = assigned.map(a => a.user_id);

//       // ✅ 4. DERIVE AVAILABLE FROM CACHE
//       const available = allEngineers
//         .filter(e => !assignedIds.includes(e.user_id))
//         .map(e => ({
//           user_id: e.user_id,
//           first_name: e.first_name,
//           last_name: e.last_name,
//           isAssigned: false,
//         }));

//       setAssignedEngineers(assigned);
//       setAvailableEngineers(available);

//     } catch (err) {
//       toast.error("Failed to fetch mapping data");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleAction = async (engineer, action) => {
//     const isAssigning = action === 'assign';
//     const endpoint = isAssigning
//       ? 'assign_site_to_engineer_customer'
//       : 'unassign_site_from_engineer_customer';

//     const payload = {
//       engineer_id: engineer.user_id,
//       customer_id: selectedCustomer,    // ✅ INTEGER
//       asset_id: selectedSiteObj?.asset_id      // ✅ INTEGER
//     };

//     try {
//       await axios.post(`${API_URL}/api/${endpoint}/`, payload, getConfig());

//       if (isAssigning) {
//         setAssignedEngineers([
//           ...assignedEngineers,
//           { ...engineer, isAssigned: true }
//         ]);
//         setAvailableEngineers(
//           availableEngineers.filter(e => e.user_id !== engineer.user_id)
//         );
//       } else {
//         setAvailableEngineers([
//           ...availableEngineers,
//           { ...engineer, isAssigned: false }
//         ]);
//         setAssignedEngineers(
//           assignedEngineers.filter(e => e.user_id !== engineer.user_id)
//         );
//       }

//       toast.success(`Engineer ${isAssigning ? 'Assign' : 'Unassign'} successfully`);

//     } catch (err) {
//       toast.error(err.response?.data?.error || "Action failed");
//     }
//   };

//   const getFilteredData = () => {
//     if (tabValue === 1) return assignedEngineers;
//     if (tabValue === 2) return availableEngineers;
//     return [...assignedEngineers, ...availableEngineers];
//   };

//   return (
//     <>
//       <Paper className="main-card-ui">
//         <Box
//           className="header-row"
//           sx={{
//             display: "flex",
//             gap: 2,                // controls spacing between dropdowns
//             justifyContent: "flex-start", // 👈 important (removes huge gap)
//             alignItems: "center"
//           }}
//         >
//           {/* Dropdown 1: Supervisor */}
//           {/* <TextField
//             select
//             label="Select Supervisor"
//             value={selectedSupervisor}
//             onChange={handleSupervisorChange}
//             size="small"
//              sx={{ width: 250 }} 

//           >
//             {supervisors.map((sup) => (
//               <MenuItem key={sup.id?.id || sup.id} value={sup.id?.id || sup.id}>
//                 {sup.firstName || sup.first_name} {sup.lastName || sup.last_name}
//               </MenuItem>
//             ))}
//           </TextField> */}


//           <TextField
//             select
//             label="Select Customer"
//             value={selectedCustomer}
//             onChange={handleCustomerChange}
//             size="small"
//             sx={{ width: 250 }}
//           >
//             {customers.map((c) => (
//               <MenuItem key={c.tb_customer_id} value={c.tb_customer_id}>
//                 {c.customer_name}
//               </MenuItem>
//             ))}
//           </TextField>

//           {/* Dropdown 2: Site */}
//           <TextField
//             select
//             label="Select Site"
//             value={selectedSite}
//             onChange={handleSiteChange}
//             size="small"
//             sx={{ width: 250 }}
//             disabled={!selectedCustomer}
//           >

//             {sites.map((site) => (
//               <MenuItem key={site.asset_id} value={site.asset_id}>
//                 {site.name}
//               </MenuItem>
//             ))}

//           </TextField>
//         </Box>

//         <Box className="badge-container" sx={{ justifyContent: 'flex-end', mb: 2 }}>
//           <div className="status-badge assigned">Assign: {assignedEngineers.length}</div>
//           <div className="status-badge available">Available: {availableEngineers.length}</div>
//         </Box>

//         <Box className="tabs-wrapper">
//           <Tabs value={tabValue} onChange={(e, v) => setTabValue(v)} centered className="custom-tabs">
//             <Tab label="All" />
//             <Tab label="Assigned" />
//             <Tab label="Available" />
//           </Tabs>
//         </Box>

//         <TableContainer className="table-container-ui orange-table">
//           {loading ? (
//             <Box textAlign="center" p={5}><CircularProgress /></Box>
//           ) : (
//             <Table stickyHeader sx={{ tableLayout: "fixed", width: "100%" }}>
//               <TableHead>
//                 <TableRow>
//                   <TableCell align="center">Engineer Name</TableCell>
//                   {/* <TableCell>User ID</TableCell> */}
//                   <TableCell align="center">Action</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {getFilteredData().slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
//                   .map((row) => (
//                     <TableRow key={row.user_id || row.id}>
//                       <TableCell align="center">{row.first_name} {row.last_name}</TableCell>
//                       {/* <TableCell className="code-text">{row.user_id}</TableCell> */}
//                       <TableCell align="center">
//                         {row.isAssigned ? (
//                           <Button className="btn-unmap" onClick={() => handleAction(row, 'unassign')}>Unassign</Button>
//                         ) : (
//                           <Button className="btn-map" onClick={() => handleAction(row, 'assign')}>Assign</Button>
//                         )}
//                       </TableCell>
//                     </TableRow>
//                   ))}
//               </TableBody>
//             </Table>
//           )}

//           {/* Add this after </TableContainer> */}
//           {!loading && getFilteredData().length > 0 && (
//             <div className="pagination-bar">
//               <div className="rows-select">
//                 Rows per page:
//                 <select value={rowsPerPage} onChange={handleChangeRowsPerPage}>
//                   <option value={5}>5</option>
//                   <option value={10}>10</option>
//                   <option value={25}>25</option>
//                 </select>
//               </div>
//               <div className="page-info">
//                 {page * rowsPerPage + 1}-
//                 {Math.min((page + 1) * rowsPerPage, getFilteredData().length)} of {getFilteredData().length}
//               </div>
//               <div className="page-arrows">
//                 <button disabled={page === 0} onClick={() => setPage(page - 1)}>‹</button>
//                 <button
//                   disabled={(page + 1) * rowsPerPage >= getFilteredData().length}
//                   onClick={() => setPage(page + 1)}
//                 >
//                   ›
//                 </button>
//               </div>
//             </div>
//           )}
//         </TableContainer>
//       </Paper>
//       <ToastContainer position="top-right" autoClose={2000} />
//     </>
//   );
// };

// export default MapSiteToEngineer;























import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Box, TextField, MenuItem, Paper, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Button, CircularProgress, Tabs, Tab
} from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./MapParameter.css";
import apiService from "../../utils/apiservice";

const API_URL = process.env.REACT_APP_API_DJANGO_URL;

const MapSiteToEngineer = () => {
  const [sites, setSites] = useState([]);
  const [selectedSite, setSelectedSite] = useState("");
  const [assignedEngineers, setAssignedEngineers] = useState([]);
  const [availableEngineers, setAvailableEngineers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [selectedSiteObj, setSelectedSiteObj] = useState(null);

  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [engineers, setEngineers] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  useEffect(() => {
    setPage(0);
  }, [tabValue, selectedSite]);

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getConfig = () => ({
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: {},
  });

  // REUSABLE FUNCTION: Maps engineers based on an active assetId and explicit engineer list
  const fetchMappingData = async (assetId, currentEngineers) => {
    if (!assetId || !currentEngineers || currentEngineers.length === 0) return;

    try {
      setLoading(true);
      const assignedRes = await axios.get(
        `${API_URL}/api/get_site_engineers_of_site/${assetId}/`,
        getConfig()
      );
      
      const assignedList = assignedRes.data.engineers || [];
      const assignedIds = new Set(assignedList.map(e => String(e.user_id)));

      const assigned = assignedList.map(e => ({
        user_id: String(e.user_id),
        first_name: e.first_name,
        last_name: e.last_name,
        isAssigned: true,
      }));

      const available = currentEngineers
        .filter(e => !assignedIds.has(String(e.user_id)))
        .map(e => ({
          user_id: String(e.user_id),
          first_name: e.first_name,
          last_name: e.last_name,
          isAssigned: false,
        }));

      setAssignedEngineers(assigned);
      setAvailableEngineers(available);
    } catch (err) {
      toast.error("Failed to fetch mapping data");
    } finally {
      setLoading(false);
    }
  };

  // 1. Initial Load Sequence
  useEffect(() => {
    const initializeData = async () => {
      try {
        setLoading(true);
        const res = await apiService.get("/api/get_customers/");
        const list = res.data || [];
        setCustomers(list);

        if (list.length > 0) {
          const firstCustomerId = list[0].tb_customer_id;
          setSelectedCustomer(firstCustomerId);

          // Fetch Sites sequentially
          const siteRes = await apiService.get(`/api/get_customer_sites/${firstCustomerId}/`, { data: {} });
          const siteData = siteRes.data.data || [];
          setSites(siteData);

          // Fetch Engineers sequentially 
          const engRes = await apiService.get(`/api/get_customer_engineers/${firstCustomerId}/`, { data: {} });
          const engList = (engRes.data.engineers || []).filter(e => e.user_id);
          setEngineers(engList);

          // Target default site safely using freshly received variables instead of component state
          if (siteData.length > 0) {
            const firstSite = siteData[0];
            setSelectedSite(firstSite.asset_id);
            setSelectedSiteObj(firstSite);

            // Fetch mappings immediately using local lists to bypass state-update lag
            await fetchMappingData(firstSite.asset_id, engList);
          }
        }
      } catch (err) {
        toast.error("Failed to initialize page data");
      } finally {
        setLoading(false);
      }
    };

    initializeData();
  }, []);

  // 2. Handling manual Customer changes
  const handleCustomerChange = async (e) => {
    const customerId = e.target.value;
    setSelectedCustomer(customerId);
    setSites([]);
    setSelectedSite("");
    setSelectedSiteObj(null);
    setAssignedEngineers([]);
    setAvailableEngineers([]);

    try {
      setLoading(true);
      const siteRes = await apiService.get(`/api/get_customer_sites/${customerId}/`, { data: {} });
      const siteData = siteRes.data.data || [];
      setSites(siteData);

      const engRes = await apiService.get(`/api/get_customer_engineers/${customerId}/`, { data: {} });
      const engList = (engRes.data.engineers || []).filter(e => e.user_id);
      setEngineers(engList);

      if (siteData.length > 0) {
        const firstSite = siteData[0];
        setSelectedSite(firstSite.asset_id);
        setSelectedSiteObj(firstSite);
        await fetchMappingData(firstSite.asset_id, engList);
      }
    } catch (err) {
      toast.error("Failed to update layout data");
    } finally {
      setLoading(false);
    }
  };

  // 3. Handling manual Site selection changes
  const handleSiteChange = async (e) => {
    const assetId = e.target.value;
    const siteObj = sites.find(s => s.asset_id === assetId);

    setSelectedSite(assetId);
    setSelectedSiteObj(siteObj);

    // Runs using current mapped engineers list in component state
    await fetchMappingData(assetId, engineers);
  };

  const handleAction = async (engineer, action) => {
    const isAssigning = action === 'assign';
    const endpoint = isAssigning ? 'assign_site_to_engineer_customer' : 'unassign_site_from_engineer_customer';

    const payload = {
      engineer_id: engineer.user_id,
      customer_id: selectedCustomer,
      asset_id: selectedSiteObj?.asset_id
    };

    try {
      await axios.post(`${API_URL}/api/${endpoint}/`, payload, getConfig());

      if (isAssigning) {
        setAssignedEngineers([...assignedEngineers, { ...engineer, isAssigned: true }]);
        setAvailableEngineers(availableEngineers.filter(e => e.user_id !== engineer.user_id));
      } else {
        setAvailableEngineers([...availableEngineers, { ...engineer, isAssigned: false }]);
        setAssignedEngineers(assignedEngineers.filter(e => e.user_id !== engineer.user_id));
      }
      toast.success(`Engineer ${isAssigning ? 'Assigned' : 'Unassigned'} successfully`);
    } catch (err) {
      toast.error(err.response?.data?.error || "Action failed");
    }
  };

  const getFilteredData = () => {
    if (tabValue === 1) return assignedEngineers;
    if (tabValue === 2) return availableEngineers;
    return [...assignedEngineers, ...availableEngineers];
  };

  return (
    <>
      <Paper className="main-card-ui">
        <Box
          className="header-row"
          sx={{
            display: "flex",
            gap: 2,                // controls spacing between dropdowns
            justifyContent: "flex-start", // 👈 important (removes huge gap)
            alignItems: "center"
          }}
        >
          {/* Dropdown 1: Supervisor */}
          {/* <TextField
            select
            label="Select Supervisor"
            value={selectedSupervisor}
            onChange={handleSupervisorChange}
            size="small"
             sx={{ width: 250 }} 

          >
            {supervisors.map((sup) => (
              <MenuItem key={sup.id?.id || sup.id} value={sup.id?.id || sup.id}>
                {sup.firstName || sup.first_name} {sup.lastName || sup.last_name}
              </MenuItem>
            ))}
          </TextField> */}


          <TextField
            select
            label="Select Customer"
            value={selectedCustomer}
            onChange={handleCustomerChange}
            size="small"
            sx={{ width: 250 }}
          >
            {customers.map((c) => (
              <MenuItem key={c.tb_customer_id} value={c.tb_customer_id}>
                {c.customer_name}
              </MenuItem>
            ))}
          </TextField>

          {/* Dropdown 2: Site */}
          <TextField
            select
            label="Select Site"
            value={selectedSite}
            onChange={handleSiteChange}
            size="small"
            sx={{ width: 250 }}
            disabled={!selectedCustomer}
          >

            {sites.map((site) => (
              <MenuItem key={site.asset_id} value={site.asset_id}>
                {site.name}
              </MenuItem>
            ))}

          </TextField>
        </Box>

        <Box className="badge-container" sx={{ justifyContent: 'flex-end', mb: 2 }}>
          <div className="status-badge assigned">Assign: {assignedEngineers.length}</div>
          <div className="status-badge available">Available: {availableEngineers.length}</div>
        </Box>

        <Box className="tabs-wrapper">
          <Tabs value={tabValue} onChange={(e, v) => setTabValue(v)} centered className="custom-tabs">
            <Tab label="All" />
            <Tab label="Assigned" />
            <Tab label="Available" />
          </Tabs>
        </Box>

        <TableContainer className="table-container-ui orange-table">
          {loading ? (
            <Box textAlign="center" p={5}><CircularProgress /></Box>
          ) : (
            <Table stickyHeader sx={{ tableLayout: "fixed", width: "100%" }}>
              <TableHead>
                <TableRow>
                  <TableCell align="center">Engineer Name</TableCell>
                  {/* <TableCell>User ID</TableCell> */}
                  <TableCell align="center">Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {getFilteredData().slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => (
                    <TableRow key={row.user_id || row.id}>
                      <TableCell align="center">{row.first_name} {row.last_name}</TableCell>
                      {/* <TableCell className="code-text">{row.user_id}</TableCell> */}
                      <TableCell align="center">
                        {row.isAssigned ? (
                          <Button className="btn-unmap" onClick={() => handleAction(row, 'unassign')}>Unassign</Button>
                        ) : (
                          <Button className="btn-map" onClick={() => handleAction(row, 'assign')}>Assign</Button>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          )}

          {/* Add this after </TableContainer> */}
          {!loading && getFilteredData().length > 0 && (
            <div className="pagination-bar">
              <div className="rows-select">
                Rows per page:
                <select value={rowsPerPage} onChange={handleChangeRowsPerPage}>
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                </select>
              </div>
              <div className="page-info">
                {page * rowsPerPage + 1}-
                {Math.min((page + 1) * rowsPerPage, getFilteredData().length)} of {getFilteredData().length}
              </div>
              <div className="page-arrows">
                <button disabled={page === 0} onClick={() => setPage(page - 1)}>‹</button>
                <button
                  disabled={(page + 1) * rowsPerPage >= getFilteredData().length}
                  onClick={() => setPage(page + 1)}
                >
                  ›
                </button>
              </div>
            </div>
          )}
        </TableContainer>
      </Paper>
      <ToastContainer position="top-right" autoClose={2000} />
    </>
  );
};

export default MapSiteToEngineer;